const rideFlags = {
    NO: 0,
    OUT_OF_NETWORK: 1,
    LOCKED_RIDE: 2
};
Object.freeze(rideFlags);
export default rideFlags;
